import styled from 'styled-components';
import { Link } from 'react-router-dom';
export const StyledFooter = styled.footer`
  width: 100%;
  background: var(--paper);
  border-top: 1px solid var(--line);
  padding: 70px var(--gutter);
`;
export const Container = styled.div`
  width: 100%;
  max-width: 1248px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 0.8fr 2fr;
  gap: 70px;
  > div:last-child {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
  }
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  @media (max-width: 650px) {
    > div:last-child {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 28px 20px;
    }
  }
`;
export const Slogan = styled.p`
  font-size: 1.6rem;
  line-height: 1.5;
  color: var(--muted);
  margin: 18px 0 0;
`;
export const LogoLink = styled(Link)`
  display: inline-flex;
`;
export const LogoAnchor = styled.a`
  display: inline-flex;
`;
export const Logo = styled.img`
  width: 140px;
  height: 44px;
  object-fit: contain;
`;
export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const ListTitle = styled.h3`
  font-size: 1.1rem;
  letter-spacing: 0.1em;
  color: var(--muted);
  margin: 0 0 10px;
  font-weight: 500;
`;
export const ListItem = styled.li`
  margin: 0;
  padding: 0;
`;
export const ListLink = styled(Link)`
  font-size: 1.3rem;
  color: var(--ink);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
export const ListAnchor = styled.a`
  font-size: 1.3rem;
  color: var(--ink);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

// Retain the export used by the archived footer variant.
export const Button = styled(Link)`
  display: inline-flex;
  padding: 12px 20px;
  border: 1px solid var(--line);
  border-radius: 999px;
  color: var(--ink);
`;

export const FooterSignature = styled.div`
  max-width: 1248px;
  margin: 0 auto 56px;
  padding: 0 0 36px;
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 28px;
  border-bottom: 1px solid var(--ink);
  p {
    font-size: clamp(3.6rem, 5.2vw, 7.4rem);
    line-height: 1;
    font-weight: 550;
    letter-spacing: -0.065em;
    max-width: 800px;
    margin: 0;
  }
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 76px;
    border: 1px solid var(--ink);
    border-radius: 50%;
    flex-shrink: 0;
    font-size: 4rem;
    text-decoration: none;
    transition:
      background 0.2s,
      transform 0.2s;
  }
  a:hover {
    background: var(--surface-strong);
    transform: rotate(8deg);
  }
  @media (max-width: 760px) {
    align-items: center;
    a {
      width: 52px;
      height: 52px;
      font-size: 3rem;
    }
  }
`;
export const Wordmark = styled.div`
  max-width: 1248px;
  margin: 70px auto 0;
  padding-top: 28px;
  border-top: 1px solid var(--line);
  display: flex;
  flex-wrap: wrap;
  gap: 24px 40px;
  align-items: baseline;
  justify-content: space-between;
  strong {
    display: block;
    flex: 0 0 auto;
    white-space: nowrap;
    padding-right: 0.12em;
    font-size: clamp(6rem, 14.4vw, 21rem);
    line-height: 1;
    letter-spacing: -0.085em;
    font-weight: 650;
    color: #e7e8e5;
    background: linear-gradient(175deg, #dfe1dd 5%, #eceeeb 65%, #f4f5f3);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  span {
    font: 1rem/1.6 var(--font-mono);
    max-width: 260px;
    text-align: right;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    color: var(--muted);
  }
  @media (max-width: 760px) {
    flex-direction: column;
    gap: 24px;
    span {
      text-align: left;
    }
  }
`;
